// extracted by mini-css-extract-plugin
export var closeButton = "_jn-1";
export var closeX = "_jn-3";
export var container = "_jn-0";
export var image = "_jn-2";